import React, { useState } from "react";
import { Box, Container, Divider, Typography } from "@mui/material";
import Button from "../Button/Button";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";
import useMediaQuery from "@mui/material/useMediaQuery";
import IosShareIcon from "@mui/icons-material/IosShare";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import Machine from "../../../assets/images/machine-imageview.png";
import ImageViewModal from "./ImageViewModal";

function AllImageViewModal({ open, setOpen }) {
  const [openImageView, setOpenImageView] = useState(false);
  const handleImageView = (bool) => {
    setOpenImageView(bool);
  };
  const handleClose = () => setOpen(false);
  const mobMatch = useMediaQuery("(max-width:600px)");
  const imgArr = [Machine, Machine, Machine, Machine, Machine];
  return (
    <Modal
      sx={{
        width: "100vw",
        height: "100%",
        background: "#fff",
      }}
      hideBackdrop={true}
      open={open}
      onClose={handleClose}
    >
      <Box
        sx={{
          display: "flex",
          flexFlow: "column",
          width: "100%",
          height: "100%",
        }}
      >
        <Box
          sx={{
            padding: "16px 24px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: "1px solid #D6D6D6",
          }}
        >
          <CloseIcon
            onClick={handleClose}
            sx={{
              width: "24px",
              height: "24px",
              color: "#255CCE",
              "&:hover": {
                cursor: "pointer",
              },
            }}
          />

          {mobMatch && (
            <Box sx={{ display: "flex", columnGap: "16px" }}>
              <FavoriteBorderIcon
                sx={{ color: "#255CCE", width: "32px", height: "32px" }}
              />
              <IosShareIcon
                sx={{ color: "#255CCE", width: "32px", height: "32px" }}
              />
            </Box>
          )}
          {!mobMatch && (
            <Box sx={{ display: "flex", columnGap: "16px" }}>
              <Button
                hoverBg="#fff"
                hoverTxColor="#000"
                variant="outlined"
                outColor="#255CCE"
                txColor="#255CCE"
                typoVariant="subtitle2"
                typoSize="14px"
                fontWeight="600"
                sx={{
                  "&:hover": {
                    backgroundColor: "#fff",
                    "& .MuiSvgIcon-root": {
                      fill: "#000",
                    },
                  },
                }}
                startIcon={
                  <IosShareIcon
                    sx={{ color: "#255CCE", width: "12px", height: "12px" }}
                  />
                }
              >
                Share
              </Button>
              <Button
                sx={{
                  "&:hover": {
                    backgroundColor: "#fff",
                    "& .MuiSvgIcon-root": {
                      fill: "#000",
                    },
                  },
                }}
                hoverBg="#fff"
                hoverTxColor="#000"
                variant="outlined"
                outColor="#255CCE"
                txColor="#255CCE"
                typoVariant="subtitle2"
                typoSize="14px"
                fontWeight="600"
                startIcon={
                  <FavoriteBorderIcon
                    sx={{ color: "#255CCE", width: "12px", height: "12px" }}
                  />
                }
              >
                Save
              </Button>
            </Box>
          )}
        </Box>
        <Box
          sx={{
            width: "100%",
            // height: "100%",
            display: "flex",
            flexFlow: "column",
            alignItems: "center",
            marginY: "32px",
            rowGap: "8px",
            overflowY: "scroll",
            "::-webkit-scrollbar": {
              display: "none",
            },
          }}
        >
          {imgArr.map((img, index) => {
            return (
              <Box
                onClick={() => {
                  handleImageView(true);
                }}
                key={index}
                sx={{
                  width: { xs: "100%", md: "800px" },
                  height: { xs: "231px", md: "500px" },
                  objectFit: "contain",
                  cursor: "pointer",
                }}
              >
                <img
                  src={img}
                  alt="machine"
                  style={{ width: "100%", objectFit: "contain" }}
                />
              </Box>
            );
          })}
        </Box>
        <ImageViewModal
          images={imgArr}
          open={openImageView}
          setOpen={handleImageView}
        />
      </Box>
    </Modal>
  );
}

export default AllImageViewModal;
